export default __webpack_public_path__ + "static/media/logo2.329cbf19.svg";